export const style = {
  legendObject: {
    display: "inline-block",
    padding: 5,
    fontSize: 11,
    marginLeft: -1,
    cursor: "pointer"
  }
};
